<div class="w-[368px] h-[22px] flex items-center justify-between">
  <span class="overflow-x-hidden text-on-primary  mat-body-medium">{{ data.message }}</span>
  <button mat-icon-button (click)="snackBarRef.dismiss()" [id]="'closeButton'">
    <mat-icon class="material-symbols-rounded cursor-pointer  text-on-primary ">close </mat-icon>
  </button>
</div>